// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prof-about-section__text[data-v-4392f59f] {\n  display: block;\n  width: 100%;\n  margin: 0;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
